var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveCasino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.804 14.492a.366.366 0 0 0-.043-.023l-6.823-3.513a1.723 1.723 0 0 0-1.741 0c-.545.315-.87.879-.87 1.509v7.07c0 .63.325 1.194.87 1.509.278.16.583.238.882.238.288 0 .57-.072.817-.216l6.908-3.558c.545-.316.87-.88.87-1.508s-.325-1.192-.87-1.508zm-7.478-1.602 6.04 3.11-6.04 3.112V12.89zM25.905 6.1a1 1 0 1 0-1.414 1.415C26.754 9.777 28 12.79 28 16s-1.246 6.223-3.509 8.485a1 1 0 1 0 1.414 1.414C28.545 23.26 30 19.744 30 16s-1.454-7.26-4.095-9.9z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.033 8.974a1 1 0 1 0-1.414 1.414c3.095 3.094 3.095 8.13 0 11.224a1 1 0 1 0 1.414 1.414c1.874-1.874 2.906-4.369 2.906-7.026s-1.032-5.152-2.906-7.026zM7.508 7.515A1 1 0 1 0 6.094 6.1C3.454 8.74 2 12.257 2 16s1.454 7.26 4.094 9.9a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.415c-4.678-4.678-4.678-12.292 0-16.97z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.381 8.974a1 1 0 0 0-1.414 0C7.093 10.848 6.061 13.343 6.061 16s1.032 5.152 2.906 7.026a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414c-1.496-1.496-2.32-3.489-2.32-5.612s.824-4.116 2.32-5.612a1 1 0 0 0 0-1.414z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCasino);
export default __webpack_public_path__ + "static/media/live-casino.3f8ba826cca20e802081cbb1f1b9b718.svg";
export { ForwardRef as ReactComponent };